import { Checkbox } from '@schuettflix/react-components';
import { z } from 'zod';
import { useTranslation } from 'react-i18next';

const DRIVER_ACTION_MAP = {
    weighingData: 'location.driverActions.weighingOption',
    photoProof: 'location.driverActions.photoProofOption',
    additionalSignatures: 'location.driverActions.additionalSignaturesOption',
} as const;

type DriverActionId = keyof typeof DRIVER_ACTION_MAP;

export const DriverActionSchema = z.object({
    id: z.enum(Object.keys(DRIVER_ACTION_MAP) as [DriverActionId]),
});

export type DriverAction = z.infer<typeof DriverActionSchema>;

interface DriverActionsProps {
    isLoadingLocation: boolean;
    value: DriverAction[];
    onChange: (driverActions: DriverAction[]) => void;
}
const DriverActions = ({ isLoadingLocation, value, onChange }: DriverActionsProps) => {
    const { t } = useTranslation();

    const title = isLoadingLocation
        ? t('location.driverActions.loadingTitle')
        : t('location.driverActions.unloadingTitle');

    const handleCheckChange = (id: string, checked: boolean) => {
        if (checked) {
            if (!value.some(action => action.id === id)) {
                onChange([...value, { id } as DriverAction]);
            }
        } else {
            onChange(value.filter(action => action.id !== id));
        }
    };
    return (
        <div className="space-y-2">
            <h3 className="font-copy-md-strong text mb-4">{title}</h3>
            <div className="flex flex-col gap-4">
                {Object.entries(DRIVER_ACTION_MAP).map(([id, label]) => (
                    <div key={id} className="flex items-center gap-4">
                        <Checkbox
                            checked={value.some(action => action.id === id)}
                            onCheckedChange={checked => handleCheckChange(id, !!checked)}
                            name={`driver-action-${id}`}
                            data-test={`driver-action-${id}`}
                            id={`driver-action-${id}`}
                        />
                        <label
                            htmlFor={`driver-action-${id}`}
                            className="text-interactive font-copy-md ml-2 cursor-pointer"
                        >
                            {t(label)}
                        </label>
                    </div>
                ))}
            </div>
        </div>
    );
};

export { DriverActions };
